export default __webpack_public_path__ + "static/media/risk-evaluation.3aebc884.svg";